module.exports = __webpack_public_path__ + "files/7878ebdf1cc2a62b227742c089e209ef.png";